import { Component } from "@angular/core";
import { ManagerManagementService } from "./managerManagement.service";
import { DepartmentService } from "../department/department.service";
import { ToastsManager } from "ng2-toastr/ng2-toastr";

@Component({
	selector: "managerManagement",
	templateUrl: "/app/managerManagement/managerManagement.template.html",
	providers: [ManagerManagementService, DepartmentService]
})
export class ManagerManagementComponent {

	managers: Array<IManagerManagement>;
	departments: Array<IDepartmentModel>;
	manager = {} as IManagerManagement;
	editMode = false;
	selectedDepartment: IDepartmentModel = null;
	display = [] as Array<Array<IManagerManagement>>;

	constructor(private managerManagementService: ManagerManagementService, private departmentService: DepartmentService, private toast: ToastsManager) { }

	ngOnInit() {
		this.getManagers();
		this.getDepartments();
	}

	getManagers(): void {
		this.managerManagementService.getManagerManagement().subscribe((result: Array<IManagerManagement>) => {
			if (result) {
				this.managers = result;

				let chunk = [] as Array<IManagerManagement>;
				this.display = [] as Array<Array<IManagerManagement>>;
                this.sortManagersByGlCodeDeptName();
				let lastGlCode: string;

				this.managers.forEach((item) => {
					if(!lastGlCode || lastGlCode !== (item.glCode + "-" + item.departmentName )) {
						lastGlCode = (item.glCode + "-" + item.departmentName );

						if(chunk.length > 0)
							this.display.push(chunk);

						chunk = [];
						chunk.push(item);
					}
					else
						chunk.push(item);
				});

				this.display.push(chunk);
			}
		});
	}

	getDepartments(): void {
		this.departmentService.getDepartments().subscribe((result: Array<IDepartmentModel>) => {
			if(result)
				this.departments = result;
		});
	}

	editManager(manager: IManagerManagement): void {
		this.manager = manager;
		this.selectedDepartment = manager.id ? this.departments.find(department => department.id === manager.departmentId) : null;
		this.editMode = true;
	}

	saveManager(manager: IManagerManagement): void {
		if(manager.id)
			this.updateManager();
		else
			this.addManager();
	}

	updateManager(): void {
		this.manager.departmentId = this.selectedDepartment.id;

		this.managerManagementService.saveManager(this.manager).subscribe((result: any) => {
			if(result) {
				this.toast.success(`${this.manager.name} successfully saved.`, "Manager Saved", { toastLife: 10000 });
				this.cancelEditManager();
				this.getManagers();
			}
		});
	}

	addManager(): void {
		this.manager.departmentId = this.selectedDepartment.id;

		this.managerManagementService.addManager(this.manager).subscribe((result: any) => {
			if(result) {
				this.toast.success(`${this.manager.name} successfully added.`, "Manager Added", { toastLife: 10000 });
				this.cancelEditManager();
				this.getManagers();
			}
		});
	}

	cancelEditManager(): void {
		this.manager = {} as IManagerManagement;
		this.selectedDepartment = null;
		this.editMode = false;
	}

	sortManagersByGlCodeDeptName() {
		this.managers.sort((a, b) => {
            let glCode1 = a.glCode + "-" + a.departmentName;
            let glCode2 = b.glCode + "-" + b.departmentName

			if(glCode1 < glCode2)
				return -1;
			if(glCode1 > glCode2)
				return 1;

			return 0;
		});
	}
}